export default Object.freeze({
  PAGE_TIT: 'SMS 관리',
  TABLE_TIT: '자동SMS 유형',

  DETAIL_ONE: 'ⓘ 자동 SMS 발송을 설정할 수 있습니다.',
  DETAIL_TWO: 'Ⓘ 자동 SMS 발송은 사용함/사용안함으로 발송 여부를 설정할 수 있습니다.',
  DETAIL_THREE: 'Ⓘ [유료]로 표기된 항목은 ‘서비스관리>쇼핑몰수정>SMS발송 설정’에 SMS Appkey가 등록되어 있어야 하며, 발송요금/내역은 NHN Cloud에서 확인할 수 있습니다.',
  TERMS_DETAIL: 'Ⓘ ‘개인정보 이용내역 안내’ 템플릿을 사용하실 경우 매월 1일마다 통지 대상에게 안내가 발송됩니다.',

  AD_SMS_DETAIL: 'Ⓘ ‘광고성 SMS 수신현황안내’ 템플릿을 사용하실 경우 매월 1일 통지 대상에게 안내가 발송됩니다.',
  EVALUATION_SMS_DETAIL: 'Ⓘ ‘등급적립금 지급 안내’ 템플릿을 사용하실 경우, 자동 등급평가 사용여부가 ‘사용함’ 이어야 안내가 발송됩니다.',

  AD_EMAIL_DETAIL: 'Ⓘ ‘광고성 정보 수신현황안내’ 템플릿을 사용하실 경우 매월 1일 통지 대상에게 안내가 발송됩니다.',
  MUST_EDIT_DETAIL: 'Ⓘ ‘개인정보이용내역 안내’ 템플릿 내용에 포함된 ‘개인정보 이용내역 확인’ 버튼 경로는 개인정보 동의여부 및 이용내역을 확인할 수 있는 쇼핑몰 페이지로 수정하셔야 합니다.',
  EVALUATION_EMAIL_DETAIL: 'Ⓘ ‘등급적립금 지급 안내’는 자동 등급평가 사용여부가 ‘사용함’인 경우 안내가 발송됩니다.',
  SEND_NOTICE: 'Ⓘ 관계 법령에 따라 정보주체 외 개인정보 수집(간편 로그인/가입, 회원연동) 시 수집출처 등을 안내하여야 합니다. 상세 내용은 <a class="oauth_type_button">[여기]</a>에서 확인 가능합니다.',

  // layer
  TERMS_NOTICE_TITLE: '개인정보 이용내역 안내 템플릿 사용 안내',
  TERMS_NOTICE_TEXT_1:
    '개인정보 보호법 제39조의8에 따라 수집한 이용자의 개인정보 이용내역을 주기적으로 이용자에게 통지하여야 합니다.',
  TERMS_NOTICE_TEXT_2:
    '아래 항목 중 한가지 이상에 해당하는 법적 의무대상자는 반드시 개인정보 이용내역을 통지하고 수신동의 여부를 확인하여야 합니다.<br/>' +
    '1. 정보통신서비스 부문 전년도(법인인 경우에는 전 사업연도를 말한다) 매출액이 100억원 이상인 정보통신서비스 제공자등<br/>' +
    '2. 전년도 말 기준 직전 3개월간 그 개인정보가 저장ㆍ관리되고 있는 이용자 수가 일일평균 100만명 이상인 정보통신서비스 제공자등',
  TERMS_NOTICE_TEXT_3:
    '개인정보 이용내역 통지 시, 아래 항목들을 명시하시기 바랍니다.<br/>' +
    '1. 개인정보의 수집ㆍ이용 목적 및 수집한 개인정보의 항목<br/>' +
    '2. 개인정보를 제공받은 자와 그 제공 목적 및 제공한 개인정보의 항목',
  AD_NOTICE_TITLE_SMS: '광고성 SMS 수신현황안내 템플릿 사용 안내',
  AD_NOTICE_TITLE_MAIL: '광고성 정보 수신현황안내 템플릿 사용 안내',
  AD_NOTICE_TEXT_1: '정보통신망법 제50조에 따라 2년마다 광고성 정보 수신자의 수신동의 여부를 확인하여야 합니다.',
  AD_NOTICE_TEXT_2:
    '수신동의 여부 확인 시, 아래 항목들을 명시하시기 바랍니다.<br/>' +
    '1. 전송자의 명칭<br/>' +
    '2. 수신자의 수신동의 사실과 수신에 동의한 날짜<br/>' +
    '3. 수신동의에 대한 유지 또는 철회의 의사를 표시하는 방법',
  USED: '사용함',
  NOT_USED: '사용 안 함',
  ARCODION_LST_EMPTY: '',
  BTN_PREVIEW: '미리보기',
  BTN_EDIT: '편집하기',
  BTN_HELP: '치환 텍스트 보기',
  BTN_SAVE: '저장',
  WARN_USER: '사용 메시지만 미리보기가 가능합니다.',
  WARN_NULL: '템플릿 내용을 입력해 주세요.',
  SUCCESS_SEND: '변경사항이 저장되었습니다.',
  INTERCHANGE_GUIDE:
    '자동SMS 발송메시지 설정 시 아래 치환텍스트를 이용하여 SMS 수신자에게 알맞은 내용을 전송할 수 있습니다.',
  TH_1: '치환 텍스트',
  TH_2: '설명',
  TH_3: '예시',
  TH_4: '비고',
  HELP_TITLE: '치환텍스트 목록',
  MAIL_PARAMETERS: [
    { key: '${mallName}', desc: '쇼핑몰명', example: '샘플몰', note: '쇼핑몰관리에서 설정한 쇼핑몰 명' },
    { key: '${name}', desc: '회원명', example: '홍길동', note: '' },
    { key: '${pwd}', desc: '임시비밀번호', example: 'password12!!', note: '시스템에 의해 자동 생성된 비밀번호 발송' },
    {
      key: '${tel}',
      desc: '고객센터전화번호',
      example: '02-0000-0000',
      note: '쇼핑몰관리에서 설정한 고객센터 전화번호',
    },
    { key: '${banStartDate}', desc: '이용정지시작일', example: '2017년08월11일', note: '' },
    {
      key: '${banEndDate}',
      desc: '이용정지종료일',
      example: '2017년08월11일',
      note: '영구정지인 경우 \'기한없음\'으로 표시',
    },
    { key: '${inactiveDate}', desc: '휴면회원처리예정일', example: '2017년08월11일', note: '' },
	  { key: '${oauthType}', desc: '개인정보 수집출처', example: '페이코', note: '타 업체를 통해 개인정보를 수집한 경우(ex. 간편 로그인)  개인정보를 수집한 출처' },
    { key: '${smsAgreeDate}', desc: 'SMS수신동의설정 최종변경일', example: '2017년08월11일', note: '' },
    { key: '${pointNm}', desc: '적립금명', example: '마일리지', note: '쇼핑몰관리에서 설정한 적립금명' },
    { key: '${pointDelMonth}', desc: '소멸예정월', example: '8월', note: '' },
    { key: '${dueDate}', desc: '적립금 소멸예정일', example: '2017-08-11', note: '' },
    { key: '${pointTotal}', desc: '소멸예정 적립금 합계', example: '27,000', note: '' },
    { key: '${bankName}', desc: '은행명', example: '신한은행', note: '' },
    { key: '${accountHolder}', desc: '예금주명', example: '홍길동', note: '' },
    { key: '${account}', desc: '결제계좌번호', example: '1234567890', note: '쇼핑몰 무통장 또는 은행가상계좌' },
    { key: '${totalPayAmt}', desc: '적립금+실결제금액', example: '27,000', note: '' },
    { key: '${subPayAmt}', desc: '적립금', example: '2,000', note: '' },
    { key: '${mainPayAmt}', desc: '실결제금액', example: '25,000', note: '' },
    {
      key: '${depositDate}',
      desc: '입금기한',
      example: '2017년08월11일',
      note: '쇼핑몰 무통장: 미입금주문 자동취소일\n은행가상계좌: 미입금주문 자동취소일 / 가상계좌 만기일 중 짧은 것',
    },
    { key: '${depositDateShort}', desc: '입금기한 축약형', example: '2017-08-11', note: '입금기한 축약형' },
    { key: '${shortDepositDateNoYear}', desc: '입금기한축약형(년도제외)', example: '3/7', note: '' },
    {
      key: '${product}',
      desc: '주문대표상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${count}', desc: '상품수', example: '1', note: '' },
    {
      key: '${deliProduct}',
      desc: '배송대표상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${deliCom}', desc: '택배사명', example: 'CJ대한통운', note: '' },
    { key: '${deliNum}', desc: '송장번호', example: '12345678', note: '' },
    {
      key: '${returnProduct}',
      desc: '반품대표상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    {
      key: '${gift.address}',
      desc: '배송지 입력 URL',
      example: 'http://shoppingmall.com/orders/\nshipping-info?code=abcd1234',
      note: '쇼핑몰 관리에서 입력한 배송지 입력 URL',
    },
    {
      key: '${autoDepositDate}',
      desc: '정기배송 상품 결제 예정일',
      example: '22',
      note: '고객이 신청한 정기배송일',
    },
    {
      key: '${autoDepositPay}',
      desc: '정기배송 결제 예정 금액',
      example: '27,000',
      note: '정기결제 신청 내역 합산 금액',
    },
  ],
});
